<template>
    <img class="document-icon" :src="getIcon(document)" alt="">
</template>


<script>

export default {
    name: "DocIcon",
    props: ['document'],
    data() {
        return {
            
        }
    },
    mounted() {
        
    },
    computed: {
    },
    methods: {
        getIcon(document) {
            const extension = document.split('.').pop()

            switch (extension) {
                case 'pdf':
                case 'odp':
                    return 'https://www.svgrepo.com/show/375329/pdf-document.svg';

                case 'xlsx':
                case 'xls':
                case 'ods':
                    return 'https://www.svgrepo.com/download/375311/excel-document.svg';

                case 'csv':
                    return 'https://www.svgrepo.com/download/375309/csv-document.svg'

                case 'png':
                case 'jpg':
                case 'jpeg':
                case 'odg':
                    return 'https://www.svgrepo.com/show/375321/image-document.svg';

                case 'doc':
                case 'docx':
                case 'odt':
                case 'txt':
                    return 'https://www.svgrepo.com/download/375299/word-document.svg';

                case 'ppt':
                    return 'https://www.svgrepo.com/show/375330/ppt-document.svg'
            
                default:
                    return 'https://www.svgrepo.com/show/375302/unknown-document.svg';
            }
        }
    }
}
</script>

<style>
img.document-icon {
    max-width: 36px;
}
</style>